module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "primary white--text",
    attrs: {
      "fixed": _vm.fixed
    }
  }, [_c('v-avatar', {
    staticStyle: {
      "cursor": "pointer",
      "border": "2px solid white",
      "border-radius": "100%"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/logo.png"
    }
  })]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Verde Dec18")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.user) ? _c('v-chip', {
    staticClass: "transparent white--text",
    attrs: {
      "close": ""
    },
    on: {
      "input": _vm.logout
    }
  }, [_c('v-avatar', [_c('img', {
    attrs: {
      "src": _vm.user.avatar
    }
  })]), _vm._v(" "), _c('v-icon', {
    class: {
      'yellow--text': _vm.user.roles && _vm.user.roles.indexOf('tud-admin') !== -1
    }
  }, [_vm._v(_vm._s(_vm.user.admin ? 'star' : 'star_border'))]), _vm._v(" "), _c('span', {
    staticClass: "name-span"
  }, [_vm._v(" " + _vm._s(_vm.user.username))])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a28adec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toolbar.vue
// module id = 601
// module chunks = 12